<template>
    <div v-show="visible" class="focus-toast">
        <span>{{infoText}}</span>
    </div>
</template>

<script>
export default {
    props: {
      infoText: {
        default: '成功'
      },
      visible: {
        default: false,
      }
    },
}
</script>

<style lang="less" scoped>
#articleContent {
    .focus-toast {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%);
        padding: 31px 40px;
        border-radius: 10px;
        font-size: 30px!important; /* px */
        color: #FFFFFF;
        background: rgba(0,0,0,0.7);
        text-align: justify;
        z-index: 1000;
        span {
            white-space: nowrap;
            font-size: 30px!important; /* px */

        }
        .fade-enter-active, .fade-leave-active {
            transition: opacity 2.5s;
        }
        .fade-enter, .fade-leave-to {
            opacity: 0;
        }
    }
}
</style>
